import React, { Component } from "react";

import {
    Panel,
    ListGroup,
    ListGroupItem,
    Button,
    Glyphicon,
} from "react-bootstrap";
import { PAYMENT_TYPES } from "../../../config/constants";

import "./OrderDetails.css";
import security from "../../../components/common/security/security";
import { USER_ROLES } from "../../../config/constants";
import translator from "../../../components/localization/translator";
import AutocompleteInput from "../../../components/common/elements/AutocompleteInput";

class CollapseList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: this.props.expanded,
            paymentMethod: PAYMENT_TYPES.AFTER_DELIVERY.id,
            shopName: "",
            restaurant: "",
            crateShopName: false,
            restaurants: this.props.restaurants || [],
        };
        this.renderList = this.renderList.bind(this);
        this.setArrows = this.setArrows.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (!this.state.restaurants.length) {
            this.setState({ restaurants: nextProps.restaurants || [] });
        }
    }

    renderList(item, id) {
        if (typeof item === "object") {
            const location = item.location ? item.location.address : "";
            const shopName = location
                ? item.shopName - location
                : item.shopName;
            return <ListGroupItem key={id}>{shopName}</ListGroupItem>;
        }
        return <ListGroupItem key={id}>{item}</ListGroupItem>;
    }

    isCollapsed() {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    }

    getRestaurants() {
        const result = (this.props.restaurants || []).filter((restaurant) => {
            return !restaurant.deleted;
        });
        return result;
    }

    renderCreateShop() {
        if (!this.state.crateShopName) {
            return null;
        }
        return (
            <div className={"margin-for-input flex-box"}>
                <AutocompleteInput
                    inputProps={{
                        className: "input-width",
                    }}
                    items={this.getRestaurants()}
                    value={this.state.shopName}
                    onChange={(select) => {
                        if (select.length) {
                            this.setState({ shopName: select[0].name });
                            this.setState({ restaurant: select[0] });
                        }
                    }}
                    onInputChange={(value) => {
                        this.setState({ shopName: value });
                    }}
                />
                <Button
                    className={"margin-to-left"}
                    onClick={() => {

                        if (this.state.restaurant) {
                            this.props.addShop(this.state.restaurant);
                            this.setState({
                                crateShopName: false,
                                shopName: "",
                                restaurant: "",
                            });
                        }
                    }}
                    disabled={!this.state.restaurant}
                >
                    {translator.translate("_save_")}
                </Button>
            </div>
        );
    }

    renderAddShop() {
        const {
            editable,
            orderDetails: { customer, groupOrderDetails, bookId } = {},
        } = this.props;
        if (!editable || bookId) {
            return null;
        }
        return (
            <Button
                className={"add-product margin-top-left"}
                bsStyle={"primary"}
                disabled={
                    customer && customer.isGroupOrder &&
                    groupOrderDetails &&
                    groupOrderDetails.length
                }
                onClick={() => {
                    this.setState({ crateShopName: true });
                }}
            >
                <Glyphicon glyph={"plus-sign"} />
                <span className={"margin-to-left"}>
                    {translator.translate("_add_shop_")}
                </span>
            </Button>
        );
    }

    renderDivideOrder() {
        if (!this.props.editable || !this.props.orderDetails || !this.props.orderDetails.shops || this.props.orderDetails.shops.length < 2) {
            return null;
        }
        return (
            <Button
                className={"add-product margin-top-left"}
                bsStyle={"warning"}
                onClick={this.props.divideOrder}
            >
                <Glyphicon glyph={"resize-horizontal"} />
                <span className={"margin-to-left"}>
                    {translator.translate("_divide_order_")}
                </span>
            </Button>
        );
    }

    renderDivideOrderAutomatically() {
        if (!this.props.editable || !this.props.orderDetails || !this.props.orderDetails.shops || this.props.orderDetails.shops.length < 2) {
            return null;
        }
        return (
            <Button
                className={"add-product margin-top-left"}
                bsStyle={"warning"}
                onClick={this.props.divideOrderAuto}
            >
                <Glyphicon glyph={"resize-horizontal"} />
                <span className={"margin-to-left"}>
                    {translator.translate("_divide_order_auto_")}
                </span>
            </Button>
        );
    }

    renderMergeOrder() {
        if (
            !this.props.editable ||
            !this.props.orderDetails ||
            this.props.orderDetails.bookId ||
            [
                PAYMENT_TYPES.IDRAM.id,
                PAYMENT_TYPES.TEL_CELL.id,
                PAYMENT_TYPES.BY_CARD.id,
            ].includes(this.props.orderDetails.paymentType)
        ) {
            return null;
        }
        return (
            <Button
                className={"add-product margin-top-left"}
                bsStyle={"danger"}
                onClick={this.props.mergeOrder}
            >
                <Glyphicon glyph={"resize-small"} />
                <span className={"margin-to-left"}>
                    {translator.translate("_merge_order_")}
                </span>
            </Button>
        );
    }

    renderExportProductsCsv() {
        const role = security.getUser().role;

        if (
            role !== USER_ROLES.ORDER_MANAGER &&
            role !== USER_ROLES.SUPER_ADMIN
        ) {
            return null;
        }

        if (this.props.canExportProductsCsv === false) {
            return null;
        }

        const exporting = !!this.props.exportingProductsCsv;
        const hasOrder = !!(
            this.props.orderDetails && this.props.orderDetails._id
        );

        return (
            <Button
                className={"add-product margin-top-left"}
                bsStyle={"primary"}
                disabled={exporting || !hasOrder}
                onClick={(e) => {
                    e.stopPropagation();

                    if (this.props.onExportProductsCsv) {
                        this.props.onExportProductsCsv();
                    }
                }}
            >
                <Glyphicon glyph={exporting ? "refresh" : "download-alt"} />
                <span className={"margin-to-left"}>
                {exporting
                    ? translator.translate("_loading_document_")
                    : translator.translate("_export_csv_")}
            </span>
            </Button>
        );
    }

    renderListGroup() {
        const { isList, list, child } = this.props;
        let className = this.state.isOpen ? "show" : "hidden",
            additionalStyle = "";
        if (security.getUser().role === USER_ROLES.ORDER_MANAGER) {
            additionalStyle = " padding-vertical";
        }
        if (isList) {
            return (
                <ListGroup fill className={`${className} ${additionalStyle}`}>
                    {list.map(this.renderList)}
                </ListGroup>
            );
        }
        if (child) {
            className += " child-container";
        }

        if (this.props.childClassName) {
            className += ` ${this.props.childClassName}`;
        }
        return (
            <div fill="true" className={"comments scrollable " + className}>
                <span>{list}</span>
                {this.renderAddShop()}
                {this.renderDivideOrder()}
                {this.renderDivideOrderAutomatically()}
                {this.renderMergeOrder()}
                {this.renderExportProductsCsv()}
                {this.renderCreateShop()}
                {child}
            </div>
        );
    }

    setArrows() {
        let className = "glyphicon-chevron-down";
        if (this.state.isOpen) {
            className = "glyphicon-chevron-up";
        }
        return className;
    }

    render() {
        return (
            <Panel defaultExpanded={this.props.expanded} className="pointer">
                <Panel.Heading>
                    <div onClick={() => this.isCollapsed()}>
                        <span>{this.props.headerTitle}</span>
                        <span
                            className={
                                "glyphicon pull-right " + this.setArrows()
                            }
                        ></span>
                    </div>
                </Panel.Heading>
                <Panel.Body>{this.renderListGroup()}</Panel.Body>
            </Panel>
        );
    }
}

export default CollapseList;
